module.exports = flarum.extensions['ziiven-decoration-store'];